import {get, readable, writable} from "svelte/store";
import {mediaUrlStore} from "./app-store.js";


export const docsStore = readable(
    {},
    (set) => {

        const mediaUrl = get(mediaUrlStore);
        const docs = (M.docs || []).map(doc => {
            // console.log(doc, doc.fileName, (mediaUrl + M.tenantKey + '/_docs/' + doc.fileName));
            doc.url = doc.fileUrl || (mediaUrl + M.tenantKey + '/_docs/' + doc.fileName);
            return doc;
        })

        set(docs);
        return () => {}
    });

export const privacyPolicyStore = writable({
    show: false,
    accepted: true,
    title: null,
    label: null,
    url: null,
});

privacyPolicyStore.update((privacyPolicy) => {

    privacyPolicy = (M.docs || []).find(x => x.docType === 'privacy-policy');

    if (privacyPolicy) {
        privacyPolicy.show = true;
        privacyPolicy.accepted = false;
        privacyPolicy.title = privacyPolicy.title || 'Политика конфиденциальности';
        privacyPolicy.label = privacyPolicy.label || 'Я даю согласие на обработку моих персональных данных, в соответствии с Федеральным законом от 27.07.2006 г. №152-ФЗ «О персональных данных», на условиях, определенных политикой в области обработки и обеспечения безопасности персональных данных';
        privacyPolicy.url = privacyPolicy.fileUrl || (get(mediaUrlStore) + M.tenantKey + '/_docs/' + privacyPolicy.fileName);
    }
    else {
        privacyPolicy = {
            show: false,
            accepted: true
        };
    }

    return privacyPolicy;
});

export const acceptPrivacyPolicy = (accepted) => {
    privacyPolicyStore.update(x => {
        x.accepted = accepted;
        return x;
    });
}
